import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_REFINEDFILTER_SUCCESS,
    GET_REFINEDFILTER_FAILURE,
} from '../actions';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getRefinedFilters(action) {
    const params = convertObjectToQueryParams({
        ...action.payload,
    });
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/orders/orderRefineData?${params}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({
            type: GET_REFINEDFILTER_SUCCESS,
            data: result.errorCode === '10011' ? null : result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_REFINEDFILTER_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
